export default {
  sources: {
    contractFilter: "Filtrar por frecuencia contractual",
    filterAll: "Todas",
    filterContract: "Con frecuencia contractual ({n})",
    contractBadge: "Frecuencia contractual: {freq}",
    contractPending: "conector en preparación",
    studyBadge: "Fuente en estudio",
    studyOperativa: "Consulta diaria operativa desde el {date}",
    studyNoDisponible: "No disponible desde el {date}",
    studyHint: "Sin canal oficial de acceso: se consulta a diario por vías legítimas, sin compromiso de resultado. Mientras no esté disponible, estos hechos llegan por CIMA al publicarse la autorización nacional, con menos anticipación.",
    title: "Estado de fuentes",
    loadError: "No se pudo cargar la información. Comprueba tu conexión.",
    retry: "Reintentar",
    disabledDefault: "Fuente desactivada",
    monitoredSince: "Vigilada desde ",
    last: "Última comprobación: ",
    lastChange: "Última detección: ",
    next: "Próxima prevista: ",
    runNow: "Ejecutar ahora",
    runScrapeOf: "Ejecutar scrape de {name}",
    loading: "Cargando fuentes…",
    queued: "Scrape de «{name}» encolado",
    odButton: "Comprobar ahora",
    odButtonOf: "Comprobar ahora {name}",
    odHint: "Comprobación a demanda: lee una fuente del contrato ahora, sin esperar a su calendario, con el mismo proceso que la lectura programada. Los eventos que detecte van a Eventos como siempre, y a quien la lanza le llega un aviso con el resultado. Solo encuentra lo que el organismo ya ha publicado: si anuncia algo y sube el documento horas después, saldrá «sin cambios» hasta entonces. Máximo {cap} por fuente y día para el conjunto de usuarios de tu organización; no disponible de 9:00 a 10:00 ni durante el mantenimiento; sin plazo de respuesta garantizado.",
    odRemaining: "quedan {n} de {cap} hoy",
    odQueued: "En curso: comprobación en cola…",
    odQueuedHeavy: "En curso: en cola. Es una fuente de gran volumen: se ejecuta a continuación de las lecturas en curso y puede tardar.",
    odRunning: "En curso: comprobando la fuente…",
    odDoneNone: "Comprobada a las {time}{by}: sin cambios",
    odDoneOne: "Comprobada a las {time}{by}: 1 evento nuevo",
    odDoneSome: "Comprobada a las {time}{by}: {n} eventos nuevos",
    odFailed: "La comprobación de las {time}{by} no se pudo completar",
    odBy: " por {name}",
    odRequestedBy: " (la lanzó {name})",
    odQueuedMsg: "Comprobación de «{name}» en cola",
    odReason_pasada: "No disponible durante la pasada diaria, hasta las 10:00",
    odReason_mantenimiento: "No disponible durante el mantenimiento programado",
    odReason_en_curso: "Ya hay una comprobación en curso",
    odReason_leyendo: "La fuente se está leyendo ahora; lo que encuentre aparecerá al terminar",
    odReason_tope: "Ya se han hecho las {cap} comprobaciones de hoy para esta fuente",
    odReason_cola_no_disponible: "No se pudo poner en cola; inténtalo en unos minutos",
    odReason_other: "Comprobación no disponible",
    errorPrefix: "Error: ",
    tomorrow: "Mañana {time}",
    statusOk: "Activa",
    statusWarning: "Aviso",
    statusError: "Error",
    statusPending: "Pendiente",
    statusInactive: "Inactiva",
    serviceOk: "Servicio operativo",
    serviceIncident: "Incidencia en una o más fuentes",
    serviceSubtitle: "Vigilamos {total} fuentes oficiales de forma continua · {fresh}/{total} al día",
  },
};
